import React from "react";

/**
 * Premium section divider with tiny gold ornament (curated feel on flat cream).
 * Usage: <SectionDivider />  or  <SectionDivider label="THE JOURNEY" />
 */
export default function SectionDivider({ label = "" }) {
  return (
    <div className="relative w-full flex items-center justify-center py-8 sm:py-12" aria-hidden="true">
      {/* Left rule */}
      <span className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-500/40 to-amber-500/70" />
      {/* Ornament cluster */}
      <div className="mx-3 flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-amber-500/40" />
        <span className="w-1 h-4 bg-amber-500/60 rotate-45 rounded-sm" />
        <span className="relative inline-flex items-center justify-center">
          <span className="absolute inset-0 rounded-full bg-amber-400/30 blur-md" />
          <span className="relative w-3 h-3 rotate-45 bg-gradient-to-br from-amber-300 via-amber-500 to-orange-600 shadow-md shadow-amber-500/40 rounded-[2px]" />
        </span>
        {label ? (
          <span className="text-[10px] uppercase tracking-[0.28em] text-amber-700 font-black px-2">{label}</span>
        ) : null}
        <span className="relative inline-flex items-center justify-center">
          <span className="absolute inset-0 rounded-full bg-amber-400/30 blur-md" />
          <span className="relative w-3 h-3 rotate-45 bg-gradient-to-br from-orange-600 via-amber-500 to-amber-300 shadow-md shadow-amber-500/40 rounded-[2px]" />
        </span>
        <span className="w-1 h-4 bg-amber-500/60 rotate-45 rounded-sm" />
        <span className="w-1.5 h-1.5 rounded-full bg-amber-500/40" />
      </div>
      {/* Right rule */}
      <span className="flex-1 h-px bg-gradient-to-l from-transparent via-amber-500/40 to-amber-500/70" />
    </div>
  );
}
